export default __webpack_public_path__ + "static/media/carnes.1aa0bcf1.jpg";